export default "__VITE_ASSET__CwnMuYW6__"